import { refreshBridgeTokens } from '../auth/refresh-bridge-tokens.js';
import { resetReconnectOutageTracker } from './reconnect/index.js';
import type { MainBridgeWsLifecycleParams } from './main-bridge-ws-lifecycle-types.js';

function resetAfterAuthInvalid(params: MainBridgeWsLifecycleParams): void {
  const { state } = params;
  state.reconnectAttempt = 0;
  resetReconnectOutageTracker(state.mainOutage);
  state.lastReconnectCloseMeta = null;
}

export function createMainBridgeAuthRefreshHandler(
  params: MainBridgeWsLifecycleParams,
  connect: () => void,
): () => void {
  const { apiUrl, workspaceId, logFn, tokens, persistTokens, onAuthInvalid } = params;
  let authRefreshInFlight = false;

  return () => {
    if (authRefreshInFlight) return;
    void (async () => {
      authRefreshInFlight = true;
      try {
        if (tokens.refreshToken) {
          const next = await refreshBridgeTokens({
            apiUrl,
            workspaceId,
            refreshToken: tokens.refreshToken,
          });
          if (next?.token && next.refreshToken) {
            tokens.accessToken = next.token;
            tokens.refreshToken = next.refreshToken;
            persistTokens?.({ token: tokens.accessToken, refreshToken: tokens.refreshToken });
            try {
              logFn('[Bridge service] Access token refreshed; reconnecting…');
            } catch {
              /* ignore */
            }
            resetAfterAuthInvalid(params);
            params.state.logBridgeOpenAsReconnect = true;
            authRefreshInFlight = false;
            connect();
            return;
          }
        }
        authRefreshInFlight = false;
        resetAfterAuthInvalid(params);
        onAuthInvalid();
      } catch {
        authRefreshInFlight = false;
        resetAfterAuthInvalid(params);
        onAuthInvalid();
      }
    })();
  };
}
